import { ControlParameter } from './control-parameter';
import { EigenRisicoTekst } from './eigenrisico-tekst';
import { ValidatieParameter } from './validatie-parameter';

export class Antwoord {
  constructor(init?: Partial<Antwoord>) {
    Object.assign(this, init);
  }

  id: string;
  linkt_naar: string;
  verplicht: boolean;
  standaard_waarde: string;
  standaard_waarde_tekst: string;
  stappenplan_kop: string;
  stappenplan_detail: string;
  overzicht_gemeld_links: string;
  overzicht_gemeld_rechts: string;
  variabeleWaarde: string;
  variabeleWaarden: string[];
  validatieParameters: ValidatieParameter[];
  controlParameters: ControlParameter[];
  titel: string;
  groep_id: string;
  groep_titel: string;
  icon: string;
  antwoordregels: string[];
  antwoord_bullets: string[];
  formaat: string;
  foutmelding: string;
  contractnummer: string;
  polisnummer: string;
  sleutel: string;
  kenmerk_titel: string;
  kenmerken: string[];
  dekkingen: string[];
  tekst_eigenrisico: EigenRisicoTekst[];
  eigenrisico: string;
  tekst_eigenrisico_ruitschade: string[];
  einddatum: string;
  inputAllowExtensions: string;
  errorMessage: string[];
  soortLijst: any;
  sub_control_type: string;
  // tbv contactgegevens
  hadFocus: boolean;
  waarde: string;
}
